module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__("react");
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__("styled-components");
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: external "@carvana/theme"
var theme_ = __webpack_require__("@carvana/theme");

// CONCATENATED MODULE: ./src/StarsSvg.tsx

var StarsSvg_Stars = function Stars(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/external_react_default.a.createElement("div", {
    className: className
  }, /*#__PURE__*/external_react_default.a.createElement("svg", {
    width: "110",
    height: "13",
    viewBox: "0 0 110 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/external_react_default.a.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/external_react_default.a.createElement("path", {
    d: "M7 10.78L2.67 13L3.5 8.3L0 5L4.84 4.31L7 0L9.16 4.28L14 5L10.5 8.3L11.33 13L7 10.78Z"
  }), /*#__PURE__*/external_react_default.a.createElement("path", {
    d: "M31 10.78L26.67 13L27.5 8.3L24 5L28.84 4.31L31 0L33.16 4.28L38 5L34.5 8.3L35.33 13L31 10.78Z"
  }), /*#__PURE__*/external_react_default.a.createElement("path", {
    d: "M55 10.78L50.67 13L51.5 8.3L48 5L52.84 4.31L55 0L57.16 4.28L62 5L58.5 8.3L59.33 13L55 10.78Z"
  }), /*#__PURE__*/external_react_default.a.createElement("path", {
    d: "M79 10.78L74.67 13L75.5 8.3L72 5L76.84 4.31L79 0L81.16 4.28L86 5L82.5 8.3L83.33 13L79 10.78Z"
  }), /*#__PURE__*/external_react_default.a.createElement("path", {
    d: "M103 10.78L98.67 13L99.5 8.3L96 5L100.84 4.31L103 0L105.16 4.28L110 5L106.5 8.3L107.33 13L103 10.78Z"
  }))));
};
// CONCATENATED MODULE: ./src/RatingStars.tsx




var EmptyStars = external_styled_components_default()(StarsSvg_Stars).withConfig({
  displayName: "EmptyStars",
  componentId: "sc-1glt66g-0"
})(["svg{fill:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.carvana.gray.light;
});
var FilledStars = external_styled_components_default()(StarsSvg_Stars).withConfig({
  displayName: "FilledStars",
  componentId: "sc-1glt66g-1"
})(["svg{fill:", ";}width:", "%;position:absolute;left:0;top:0;overflow:hidden;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.carvana.yellow.primary;
}, function (props) {
  return props.width * 100;
});
var StyledRatingStars = external_styled_components_default.a.span.withConfig({
  displayName: "StyledRatingStars",
  componentId: "sc-1glt66g-2"
})(["position:relative;display:inline-block;&.--blue ", " svg{fill:", ";}"], FilledStars, function (_ref3) {
  var theme = _ref3.theme;
  return theme.carvana.blue.primary;
});
var NUMBER_OF_STARS = 5;

var RatingStars_RatingStars = function RatingStars(_ref4) {
  var rating = _ref4.rating,
      blue = _ref4.blue,
      className = _ref4.className,
      _ref4$theme = _ref4.theme,
      theme = _ref4$theme === void 0 ? theme_["CarvanaTheme"] : _ref4$theme;
  return /*#__PURE__*/external_react_default.a.createElement(theme_["ThemeProvider"], {
    theme: theme
  }, /*#__PURE__*/external_react_default.a.createElement(StyledRatingStars, {
    className: className + " " + (blue ? '--blue' : '') + " "
  }, /*#__PURE__*/external_react_default.a.createElement(EmptyStars, null), /*#__PURE__*/external_react_default.a.createElement(FilledStars, {
    width: rating / NUMBER_OF_STARS
  })));
};

/* harmony default export */ var src_RatingStars = (RatingStars_RatingStars);
// CONCATENATED MODULE: ./src/index.ts

/* harmony default export */ var src = __webpack_exports__["default"] = (src_RatingStars);

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./src/index.ts");


/***/ }),

/***/ "@carvana/theme":
/***/ (function(module, exports) {

module.exports = require("@carvana/theme");

/***/ }),

/***/ "react":
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ "styled-components":
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ })

/******/ });
//# sourceMappingURL=index.js.map